import React from "react";
import { NavigationContext } from "../../../../App";
import { useContext } from "react";
import styles from "./HighEndLabServices.module.css";
import LabServiceWaves from "../../../../components/UI/LabServiceWaves";
import { useLocation, useNavigate } from "react-router-dom";


const HighEndLabServices = ({ data }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

const { setIsBackNavigation } = useContext(NavigationContext);

  return (
    <section className={`${styles.section} bg-primary-500`} id={sessionStore}>
      {/* <img
        className={styles.pattern}
        src="https://via.placeholder.com/1200x800/000000/333333?text=Pattern"
        alt="Pattern"
      /> */}
      <LabServiceWaves className={styles.pattern} />
      <img
        className={styles.patternTab}
        src="/img/patterns/lab-service-tab.svg"
      />
      <img src="/img/icons/lab-service-wave.svg" className={styles.pattern2} />
      <div className={styles.container}>
        <div className={styles.imageWrapper}>
          <img
            data-aos="fade-down"
            data-aos-delay="150"
            src={data?.listingItems[0]?.images[0]?.url}
            alt={data?.listingItems[0]?.images[0]?.imageTag}
          />
        </div>
        <div className={styles.content}>
          {data?.showTitle && (
            <div className={styles.titleFirst}>
              <h2
                data-aos="fade-right"
                data-aos-delay="150"
                dangerouslySetInnerHTML={{ __html: data?.title }}
              ></h2>
            </div>
          )}
          <h2
            data-aos="fade-right"
            data-aos-delay="150"
            className={styles.subtitle}
          >
            {data?.subTitle}
          </h2>
          <div className={styles.imageWrapper2}>
            <img
              className={styles.mainImage2}
              src={data?.listingItems[0]?.images[0]?.url}
              alt={data?.listingItems[0]?.images[0]?.imageTag}
              data-aos="fade-down"
              data-aos-delay="150"
            />
          </div>
          <div
            data-aos="fade-right"
            data-aos-delay="150"
            className={styles.description}
            dangerouslySetInnerHTML={{
              __html: data?.listingItems[0]?.homeDescription,
            }}
          />
          <button
            data-aos="fade-down"
            data-aos-delay="150"
            className={`${styles.button} primary-hover2 primary-500 border-primary-500`}
            // onClick={()=>{
            //   sessionStorage.setItem("scrollTarget", sessionStore); // Save section ID
            //   navigate(`/pages/${data?.listingItems[0]?.slug}`)}}
            onClick={() => {
              const yPos = window.scrollY;
            sessionStorage.setItem("scrollTargetY", yPos.toString());
            sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
              navigate(`/pages/${data?.listingItems[0]?.slug}`);
              setIsBackNavigation(true)
            }}
          >
            Know More
          </button>
        </div>
      </div>
    </section>
  );
};

export default HighEndLabServices;
